import { AuthContext } from '@repo-level/core-front';
import moment from 'moment';
import { useContext, useMemo } from 'react';
import { isAuroraCrystalActiveLS } from '../helpers';
import { groupMemberVIPBA, groupMemberVIPBH } from 'helpers/user';

export const useAuroraCrystalAvailable = () => {
  const { user, isAuthenticated, pendingUser } = useContext(AuthContext);

  const isUserValid = useMemo(() => {
    if (!isAuthenticated && !pendingUser) return true;
    const isVIPBA = groupMemberVIPBA(user);
    const isVIPBH = groupMemberVIPBH(user);
    return !(isVIPBA || isVIPBH);
  }, [pendingUser, isAuthenticated, user]);

  const isDateValid = useMemo(() => {
    const now = moment.utc();
    const start = moment.utc('2025-11-13 00:00', 'YYYY-MM-DD HH:mm');
    const end = moment.utc('2025-11-26 23:59', 'YYYY-MM-DD HH:mm');
    const isDateValid = now.isBetween(start, end, undefined, '[]');
    return isDateValid;
  }, []);

  const isAuroraCrystalAvailable = isAuroraCrystalActiveLS.get() === 'true';

  return {
    isAuroraCrystalPromoDate: isDateValid || isAuroraCrystalAvailable,
    isAuroraCrystalVisible:
      (isDateValid && isUserValid) || isAuroraCrystalAvailable,
    isDateValid,
    isUserValid,
  };
};
